import axios from 'axios';
import cfac22 from 'js/library/utils/cfac22';

export async function sendConfirmationEmail(uid, partnerId, languageCode) {
  const result = await axios.post(
    `${cfac22('API_HOST_V2')}/mailer/sendConfirmationEmail`,
    { uid, partnerId, languageCode },
    { headers: { 'Full-Url': window.location.href }, withCredentials: true }
  );
  return result.data;
}

